import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

const ServiceAttributes = ({ attributes, switchStates, onToggle }) => {
  return (
    <Card
      className="service-card"
      style={{ border: "0.1px solid #FD754533", borderRadius: "10px" }}
    >
      <CardBody className="p-0">
        <h5 className="customer-title mb-4">Service Attributes</h5>

        <div
          style={{
            maxHeight: "130px",
            overflowY: "auto",
            paddingRight: "10px",
          }}
        >
          <Row className="g-3">
            {attributes?.map((service) => (
              <Col xs={12} md={6} lg={4} key={service?.id}>
                <div
                  className="d-flex align-items-center justify-content-between px-3 py-1 border attr-item"
                  style={{
                    backgroundColor: "#F8FAFC",
                    minHeight: "50px",
                  }}
                >
                  <span style={{ fontWeight: "500", fontSize: "14px", color: '#0F172B' }}>
                    {service.name}
                  </span>
                  <div className="attr-control">
                    {/* simple switch using checkbox; Bootstrap/Reactstrap custom switch can also be used */}
                    <label
                      className="switch"
                      style={{ display: "inline-block" }}
                    >
                      <input
                        type="checkbox"
                        checked={switchStates[service.name] || false}
                        onChange={(e) => onToggle(service.name, service.values)}
                      />
                      <span className="slider" />
                    </label>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </CardBody>
    </Card>
  );
};

export default ServiceAttributes;
